import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BooleanObservableService {

  private subjects: { [key: string]: BehaviorSubject<boolean> };

  constructor() {
    this.subjects = {};
  }

  public bind(key: string): Observable<boolean> {

    return this.getSubject(key).asObservable();
  }

  public trigger(key: string, value: boolean): void {

    this.getSubject(key).next(value);
  }

  private getSubject(key: string): BehaviorSubject<boolean> {
    if (!this.subjects[key]) {
      this.subjects[key] = new BehaviorSubject<boolean>(false);
    }
    return this.subjects[key];
  }
}
